/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingButton } from "@mui/lab";
import { Box, FormControl, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  fetchStates,
  getDefaultState,
  setPagination,
} from "../../features/defaultSlice";
import {
  addJobManually,
  fetchData,
  getJobsData,
  setPayload,
} from "../../features/jobs/jobs";
import config from "../../utils/config";
import { AppType } from "../../utils/helper";
import { vaddJob } from "../../utils/validators";
import CustomModal from "../modals/Index";
import SelectInput from "./SelectInput";

const AddJobManually = ({ open, close }) => {
  const { state, pathname } = useLocation(),
    dispatch = useDispatch(),
    { states, modalLoading, pagination } = useSelector(getDefaultState),
    { loadingBulk, model } = useSelector(getJobsData),
    emptyModel = {
      accountNumber: "",
      accountName: "",
      dateOfIncorporation: "",
      rcNumber: "",
      state: "",
      city: "",
      address: "",
    },
    {
      setValues,
      values,
      handleBlur,
      handleChange,
      handleFocus,
      handleSubmit,
      errors,
      touched,
      resetForm,
    } = useFormik({
      validationSchema: vaddJob,
      initialValues: model,
      onSubmit: async (value) => {
        const payload = value;
        try {
          const res = await dispatch(addJobManually(payload)).unwrap();
          if (res?.success) {
            navigateBack();
          }
        } catch (error) {
          console.error(error);
        }
      },
    });

  const handleSearch = ({ target: { value } }) =>
    dispatch(setPagination({ search: value }));

  useEffect(() => {
    states?.length < 35 && dispatch(fetchStates(""));
  }, []);

  useEffect(() => {
    let cb = () => {};
    if (pagination?.search) {
      cb = setTimeout((_) => dispatch(fetchStates()), 700);
    } else cb = () => dispatch(fetchStates(""));

    return () => {
      clearTimeout(cb);
    };
  }, [pagination.search]);

  function navigateBack() {
    setValues(emptyModel);
    dispatch(setPayload(emptyModel));
    dispatch(close());
    resetForm();
    dispatch(setPagination({ search: "" }));

    if (pathname === config.routes.awaitingVendorAssignment) {
      // refetch data
      dispatch(fetchData(1));
    }
    return close;
  }

  return (
    <CustomModal
      {...{
        title: "Add Job manually",
        open,
        close: loadingBulk === false ? navigateBack : () => {},
      }}
    >
      <div className="-mt-5">
        <div className="">
          <div className="bg[#EAEAEA4D]" style={{ borderTopLeftRadius: "100" }}>
            <Box
              className="rounded-lg lg:px-[2em] px-[1em]"
              sx={{
                className: "w-[100%] lg:w-[80%]",
                py: "2em",
              }}
              noValidate
              component="form"
              onSubmit={handleSubmit}
            >
              <Box className="grid lg:grid-cols-2 gap-4 m-auto">
                <FormControl className="w-full border-none lg:mt-5">
                  <label
                    htmlFor="accountNumber"
                    className="block mb-1 text-[16px] font-medium text-[#090914]"
                  >
                    Account Number
                  </label>
                  <TextField
                    className="w-full bg-white"
                    id="accountNumber"
                    name="accountNumber"
                    value={values.accountNumber}
                    required
                    onFocus={handleFocus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.accountNumber && touched.accountNumber}
                    helperText={
                      errors.accountNumber && touched.accountNumber
                        ? errors.accountNumber
                        : ""
                    }
                  />
                </FormControl>
                <FormControl className="w-full border-none lg:mt-5">
                  <label
                    htmlFor="accountName"
                    className="block mb-1 text-[16px] font-medium  text-[#090914]"
                  >
                    Account Name
                  </label>
                  <TextField
                    className="w-full bg-white"
                    id="accountName"
                    name="accountName"
                    value={values.accountName}
                    required
                    onFocus={handleFocus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.accountName && touched.accountName}
                    helperText={
                      errors.accountName && touched.accountName
                        ? errors.accountName
                        : ""
                    }
                  />
                </FormControl>

                {AppType.cs === config.appType && (
                  <FormControl className="w-full border-none lg:mt-5">
                    <label
                      htmlFor="rcNumber"
                      className="block mb-1 text-[16px] font-medium  text-[#090914]"
                    >
                      CAC Number
                    </label>
                    <TextField
                      className="w-full bg-white"
                      id="rcNumber"
                      name="rcNumber"
                      value={values.rcNumber}
                      required
                      onFocus={handleFocus}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.rcNumber && touched.rcNumber}
                      helperText={
                        errors.rcNumber && touched.rcNumber
                          ? errors.rcNumber
                          : ""
                      }
                    />
                  </FormControl>
                )}

                <FormControl className="w-full border-none lg:mt-5">
                  <label
                    htmlFor="dateOfIncorporation"
                    className="block mb-1 text-[16px] font-medium text-[#090914]"
                  >
                    Date of Incorporation
                  </label>
                  <TextField
                    className="w-full bg-white"
                    id="dateOfIncorporation"
                    name="dateOfIncorporation"
                    type="date"
                    value={values.dateOfIncorporation}
                    required
                    onFocus={handleFocus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.dateOfIncorporation && touched.dateOfIncorporation
                    }
                    helperText={
                      errors.dateOfIncorporation && touched.dateOfIncorporation
                        ? errors.dateOfIncorporation
                        : ""
                    }
                  />
                </FormControl>

                <FormControl className="w-full border-none lg:mt-5">
                  <label
                    htmlFor="address"
                    className="block mb-1 text-[16px] font-medium text-[#090914]"
                  >
                    Account Address
                  </label>
                  <TextField
                    className="w-full bg-white"
                    id="address"
                    name="address"
                    value={values.address}
                    required
                    onFocus={handleFocus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.address && touched.address}
                    helperText={
                      errors.address && touched.address ? errors.address : ""
                    }
                  />
                </FormControl>

                <FormControl className="w-full border-none lg:mt-5">
                  <label
                    htmlFor="stateId"
                    className="block mb-1 text-[16px] font-medium  text-[#090914]"
                  >
                    Account State
                  </label>

                  <SelectInput
                    {...{
                      className: "w-full bg-white",
                      value: values.state,
                      searchValue: pagination.search,
                      id: "state",
                      name: "state",
                      handleChange,
                      handleBlur,
                      required: false,
                      handleFocus,
                      error: errors.state && touched.state,
                      helperText: errors.state,
                      loading: modalLoading,
                      searchLoading: pagination.search && modalLoading,
                      options: states.map((d) => d.Name),
                      handleSearch,
                    }}
                  />
                </FormControl>

                <FormControl className="w-full border-none lg:mt-5">
                  <label
                    htmlFor="city"
                    className="block mb-1 text-[16px] font-medium  text-[#090914]"
                  >
                    City
                  </label>
                  <TextField
                    className="w-full bg-white"
                    id="city"
                    name="city"
                    value={values.city}
                    required
                    onFocus={handleFocus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.city && touched.city}
                    helperText={errors.city && touched.city ? errors.city : ""}
                  />
                </FormControl>

                <Box className="flex justify-start mt-8 items-start">
                  <div className="flex justify-start w-full">
                    <button
                      onClick={navigateBack}
                      className="h-[3.5em] w-full items-center rounded-md px-3  text-sm font-semibold text-dark_red bg-[#f5ebeb] hover:bg-[#ffe1e0] mr-5"
                      size="large"
                      type="button"
                      disabled={loadingBulk}
                    >
                      Cancel
                    </button>

                    <LoadingButton
                      style={{ width: "100%", height: "3.5em" }}
                      className="h-[2.3rem] items-center rounded-md px-3 text-sm font-semibold bg-dark_red text-white hover:bg-light_red !capitalize"
                      variant="contained"
                      color="error"
                      sx={{
                        ".MuiLoadingButton-loadingIndicatorCenter": {
                          color: "var(--C_primary) !important",
                        },
                      }}
                      type="submit"
                      disabled={loadingBulk}
                      loading={loadingBulk}
                      fullWidth
                    >
                      {state ? "Save Changes" : "Submit"}
                    </LoadingButton>
                  </div>
                </Box>
              </Box>
            </Box>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default AddJobManually;
